import debug from 'debug';

export const Debug = debug('demostack');
